import { TOPBAR_DROPDOWN_ALIGN_LEFT } from './constants';
import { ReduxAction } from '../actions';
import { TopbarState } from './state';

const INITIAL_STATE: TopbarState = {
  expandedMenu: null,

  // This is to avoid the outline on the button right after the dropdown is expanded
  // This should be true if the TopBarButton is focus right after it has been clicked,
  // would be false once the button lost focus
  isMenuTriggeredClick: false,

  expandedMenuAlignment: TOPBAR_DROPDOWN_ALIGN_LEFT,
  siteNavRendered: false,
};

export const TopBar = (
  state: TopbarState = INITIAL_STATE,
  action: ReduxAction
): TopbarState => {
  switch (action.type) {
    case 'UPDATE_TOPBAR_EXPANDED_MENU': {
      const { menu } = action;
      return {
        ...state,
        expandedMenu: menu,
      };
    }
    case 'CLEAR_TOPBAR_EXPANDED_MENU': {
      return {
        ...state,
        expandedMenu: null,
      };
    }
    case 'UPDATE_TOPBAR_BUTTON_MENU_TRIGGERED_CLICK': {
      const { isTriggeredClick } = action;
      return {
        ...state,
        isMenuTriggeredClick: isTriggeredClick,
      };
    }
    case 'UPDATE_TOPBAR_EXPANDED_MENU_ALIGNMENT': {
      const { alignment } = action;
      return {
        ...state,
        expandedMenuAlignment: alignment,
      };
    }
    case 'UPDATE_TOPBAR_SITE_NAV_RENDERED': {
      const { rendered } = action;
      return {
        ...state,
        siteNavRendered: rendered,
      };
    }
    default: {
      return state;
    }
  }
};
